import { useEffect } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { YoutubeIframePlayer } from "../news/components/YoutubeIframePlayer";
import { useTopBarHeight } from "../../hooks/userTopBarHeight";

interface ValkyraeVideoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ValkyraeVideoModal({
  isOpen,
  onClose,
}: ValkyraeVideoModalProps) {
  const topBarHeight = useTopBarHeight();

  useEffect(() => {
    if (isOpen) {
      window.document.documentElement.style.overflow = "hidden";
      window.document.documentElement.style.scrollbarGutter = "stable";
    } else {
      window.document.documentElement.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="full"
      blockScrollOnMount={false}
      motionPreset="scale"
    >
      <ModalOverlay
        background="rgba(20, 21, 23, 0.80)"
        backdropFilter="blur(10px)"
        height={`calc(100vh - ${topBarHeight.get()}px)`}
        width="100%"
        top={`${topBarHeight.get()}px`}
        cursor="pointer"
        onClick={onClose}
      />
      <ModalContent
        background="transparent"
        boxShadow="none"
        minHeight="fit-content"
        width="100%"
        maxWidth="960px"
        height="fit-content"
        pointerEvents="all"
        onClick={(e) => e.stopPropagation()}
        containerProps={{
          height: `calc(100vh - ${topBarHeight.get()}px)`,
          width: "100%",
          top: `${topBarHeight.get()}px`,
          pointerEvents: "none",
        }}
      >
        <ModalBody
          flex="1 50% 50%"
          width="100%"
          maxWidth="960px"
          height="fit-content"
          margin="auto"
          p="8px"
        >
          <YoutubeIframePlayer
            width="100%"
            maxWidth="960px"
            maxHeight="75%"
            display="flex"
            justifyContent="center"
            onClick={onClose}
            cursor="pointer"
          >
            <iframe
              style={{
                borderRadius: "24px",
                aspectRatio: "9/16",
                maxHeight: "75vh",
              }}
              src="https://www.youtube.com/embed/nI-8D1hgMRo?autoplay=1"
              title="GlobalComix Valkyrae"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </YoutubeIframePlayer>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
